// Newsletter

var $ = jQuery;

$(document).ready(function() {
    $('section.section-newsletter input[type="submit"]').click(function(e) {
        e.preventDefault();

        var button = $(this);
        var email = $('section.section-newsletter input[name="email"]');
        var confirm_email = $('section.section-newsletter input[name="confirm_email"]');
        var data = {
            action: 'cgt_subscribe',
            email: email.val(),
            confirm_email: confirm_email.val(),
        };

        button.prop('disabled', true);
        email.prop('disabled', true);
        $('section.section-newsletter .error').hide();
        $('section.section-newsletter .error').html('');
        $.post(ajax_object.ajax_url, data, function(response) {
            if(!response.success) {
                $('section.section-newsletter .error').html(response.data.message);
                $('section.section-newsletter .error').show();
            }
            else {
                $('section.section-newsletter .confirm').show();
                email.hide();
                button.hide();
            }
            button.removeProp('disabled');
            email.removeProp('disabled');
            // gtag('event', 'Subscribed', { 'event_category': 'Email Subscribe' });
        });
    });
});



// WEBPACK FOOTER //
// ./src/js/newsletter.js